import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {PERMISSION_ALIASES} from 'core/constants/permissionAliases';
import {ROUTE} from 'core/routes';
import {billingAccess$} from 'models/profile/billing/access';

export const GridsNavigation = () => {
    const {t} = useTranslation();
    const access = useStore(billingAccess$);
    if (!access.canViewTransactions || !access.canViewInvoices) return null;
    return (
        <PermissionAccess>
            <NavBar>
                <PermissionAccess
                    permissions={[
                        PERMISSION_ALIASES.transactionsView,
                        PERMISSION_ALIASES.transactionsAllView,
                    ]}
                >
                    <NavLink exact to={ROUTE.BILLING}>
                        {t('pages.profile.billing.gridName.transactions')}
                    </NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.paymentInvoicesView]}>
                    <NavLink exact to={ROUTE.BILLING_INVOICES}>
                        {t('pages.profile.billing.gridName.invoices')}
                    </NavLink>
                </PermissionAccess>
            </NavBar>
        </PermissionAccess>
    );
};
